import { request } from "../lib/requestHelper";

/* USER identity */
export const fetchUserService = async () => {
  const data = await request("user/get-user", { method: "GET" });
  return data.user;
};

/* LOGOUT */
export const logoutUserService = async () => {
  return await request("auth/log-out", { method: "POST" });
};

/* USER DETAILS / PROFILE DETAILS */
export const fetchUserDetailsService = async (active_role) => {
  const endpoint = active_role === "user" 
    ? "user/get-user-profile-details" 
    : "artisan/get-artisan-profile-details";
    
  const data = await request(endpoint, { method: "GET" });
  return active_role === "user" ? data.userProfileData : data.artisanProfileData;
};

/* SWITCH ROLE */
export const switchRoleService = async (role) => {
  const data = await request("api/switch-role", {
    method: "POST",
    body: JSON.stringify({ role }),
  });
  return data.active_role;
};

/* FOLLOWED ARTISANS */
export const fetchFollowedArtisansService = async () => {
  const data = await request("user/get-followed-artisans", { method: "GET" });
  return data.artisans;
};

/* BIDS RECEIVED */
export const fetchAllBidsReceivedService = async () => {
  const data = await request("user/fetch-all-bids-received", { method: "GET" });
  return data.bids;
};

/* CHANGE PASSWORD */
export const changePasswordService = async (passwordData) => {
  return await request("auth/change-password", {
    method: "POST",
    body: JSON.stringify(passwordData),
  });
};

/* DELETE ACCOUNT */
export const deleteAccountService = async () => {
  return await request("auth/delete-account", { method: "DELETE" });
};
